import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const UnsotenKbn = props => {
  return <Dropdown.Static kubunKey='unsoten_kbn' {...props} />
}
